export const getAppliedFilterData = (counterPartyData, zoneList, riskLevel, reportType, riskTrend, legalConstitution, busniessSegment, caseStatus) => {
    return {
        counterpartyFilter: counterPartyData,
        zoneFilter: zoneList,
        riskLevelFilter: riskLevel,
        productNameFilter: reportType,
        riskScoreTrendFilter: riskTrend,
        legalConstitutionFilter: legalConstitution,
        businessSegmentFilter: busniessSegment,
        caseStatusFilter: caseStatus
    }
}
export const validateDatefilter = (toDate, fromDate) => {
    if (!toDate && !fromDate) {
        return true
    } else if (toDate && fromDate) {
        return true
    } else {
        return false
    }
}